module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("525dn"))).then(() => parcelRequire('ljYL6'));